import { render, staticRenderFns } from "./LottoPredictView.vue?vue&type=template&id=25c38ab9&scoped=true&lang=pug"
import script from "./LottoPredictView.vue?vue&type=script&lang=js"
export * from "./LottoPredictView.vue?vue&type=script&lang=js"
import style0 from "./LottoPredictView.vue?vue&type=style&index=0&id=25c38ab9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c38ab9",
  null
  
)

export default component.exports